import { connectBaseApi, consignmentNoteClient, createRpcMutation } from "@racoon/api";

// Consignment-note (TTN) facts live on DriverOnShift / Route / Job, so every write
// invalidates the list that carries them. Shift, route and job writes also
// invalidate the route details (getRoute caches each route under its own tag) and
// refresh the shifts: the backend re-checks completeness after any write and may
// stamp or clear DriverOnShift.consignmentNoteDoneAt, which routes carry too. Job
// writes also refresh the orders list, which shows the same jobs.
const consignmentNoteGrpc = connectBaseApi
  .enhanceEndpoints({ addTagTypes: ["Routes", "Route"] })
  .injectEndpoints({
    endpoints: (build) => ({
      addCrewMemberToShift: createRpcMutation(
        build,
        consignmentNoteClient,
        "addCrewMemberToShift",
        {
          invalidatesTags: [{ type: "DriverOnShift", id: "LIST" }],
        },
      ),
      setShiftConsignmentNote: createRpcMutation(
        build,
        consignmentNoteClient,
        "setShiftConsignmentNote",
        { invalidatesTags: ["Routes", "Route", { type: "DriverOnShift", id: "LIST" }] },
      ),
      setRouteConsignmentNotes: createRpcMutation(
        build,
        consignmentNoteClient,
        "setRouteConsignmentNotes",
        { invalidatesTags: ["Routes", "Route", { type: "DriverOnShift", id: "LIST" }] },
      ),
      setJobConsignmentNotes: createRpcMutation(
        build,
        consignmentNoteClient,
        "setJobConsignmentNotes",
        {
          invalidatesTags: ["Routes", "Route", "Order", { type: "DriverOnShift", id: "LIST" }],
        },
      ),
    }),
    overrideExisting: false,
  });

export const {
  useAddCrewMemberToShiftMutation,
  useSetShiftConsignmentNoteMutation,
  useSetRouteConsignmentNotesMutation,
  useSetJobConsignmentNotesMutation,
} = consignmentNoteGrpc;
